import React from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import SafeIcon from "../common/SafeIcon";
import * as FiIcons from "react-icons/fi";

const { FiMail, FiPhone, FiMapPin, FiBookOpen } = FiIcons;

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (targetId) => {
    // If not on home page, navigate there first
    if (location.pathname !== "/") {
      navigate("/");
      // Wait for navigation, then scroll
      setTimeout(() => {
        const element = document.getElementById(targetId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    } else {
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <div className="p-2 rounded-lg">
                <SafeIcon icon={FiBookOpen} className="h-6 w-6 text-white" />
              </div>
              <div>
                <div className="text-xl font-bold">
                  Institut Supérieur des Métiers de la Formation
                </div>
                <div className="text-sm text-gray-400">Advocaci Groupe</div>
              </div>
            </div>

            <p className="text-gray-300 mb-6 max-w-md text-sm">
              Leader de la formation professionnelle d'adultes, nous vous
              accompagnons vers l'obtention du titre professionnel de Formateur
              pour Adultes (RNCP37275).
            </p>

            <div className="space-y-3 text-sm">
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiMail} className="h-5 w-5 text-blue-400" />
                <span className="text-gray-300">
                  contact@formateurpouradulte.fr
                </span>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiPhone} className="h-5 w-5 text-blue-400" />
                <span className="text-gray-300">01 83 79 02 87</span>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-6">Navigation</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <button
                  onClick={() => scrollToSection("hero")}
                  className="text-gray-300 hover:text-white transition-colors bg-transparent border-none cursor-pointer p-0"
                >
                  Accueil
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("formation")}
                  className="text-gray-300 hover:text-white transition-colors bg-transparent border-none cursor-pointer p-0"
                >
                  Formation
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("parcours")}
                  className="text-gray-300 hover:text-white transition-colors bg-transparent border-none cursor-pointer p-0"
                >
                  Parcours
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("financement")}
                  className="text-gray-300 hover:text-white transition-colors bg-transparent border-none cursor-pointer p-0"
                >
                  Financement
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("equipe")}
                  className="text-gray-300 hover:text-white transition-colors bg-transparent border-none cursor-pointer p-0"
                >
                  Équipe & Contact
                </button>
              </li>
              <li>
                <Link
                  to="/ressources"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Ressources
                </Link>
              </li>
              <li>
                <Link
                  to="/faq"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Questions / Réponses
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-6">Liens utiles</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="https://vae.gouv.fr/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  France VAE
                </a>
              </li>
              <li>
                <a
                  href="https://www.moncompteformation.gouv.fr/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  CPF
                </a>
              </li>
              <li>
                <Link
                  to="/mentions-legales"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Mentions légales & CGV
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-xs text-gray-400">
          © 2026 Advocaci Groupe - FormateurPourAdulte.fr. Tous droits réservés.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
